import React, { useCallback } from 'react';
import Link from 'next/link';

import classnames from 'classnames/bind';
import styles from './subMenu.module.scss';
const cx = classnames.bind(styles);

interface ISubMenuItemProps {
  text: string;
  page: string;
  active: boolean;
}

const SubMenuItem = ({ text, page, active }: ISubMenuItemProps) => {
  return (
    <Link href={`/mypage/${page}`} legacyBehavior>
      <a className={cx('btnMenu', { active })} role="button">
        {text}
      </a>
    </Link>
  );
};

const subMenuDataList: Omit<ISubMenuItemProps, 'active'>[] = [
  // { text: '기본정보 관리', page: 'basic' },
  { text: '계정정보 관리', page: 'account' },
  { text: '제휴서비스 신청 관리', page: 'premium' },
  { text: '알림 관리', page: 'notice' },
];

interface IMenuProps {
  page?: string;
  onLogout: () => void;
}

const SubMenu = ({ page, onLogout }: IMenuProps) => {
  const subMenuList = subMenuDataList.map((item, idx) => {
    return <SubMenuItem key={idx} text={item.text} page={item.page} active={page === item.page} />;
  });

  const onClickLogoutBtn = useCallback(() => {
    if (onLogout) onLogout();
  }, []);

  return (
    <div className={cx('menuArea')}>
      <nav className={cx('menuWrap')}>{subMenuList}</nav>
      <a className={cx('btnLogout')} onClick={onClickLogoutBtn} role="button">
        로그아웃
      </a>
    </div>
  );
};

export default SubMenu;
